var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prod-focus"},[_c('a',{attrs:{"href":_vm.ad.TargetUrl,"target":"_blank"}},[_c('img',{staticClass:"full-w img-cover",attrs:{"src":_vm.ad.ImagePath,"alt":"产品聚焦"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }